import { React } from 'react';

import HeaderMain from '../../components/headerMain/HeaderMain.jsx';
import Footer from '../../components/footer/Footer.jsx';
import PrivacyContainer from './PrivacyContainer.jsx';

export const PrivacyPage = () => {
  const bgColor = '#58a0dc'; //бирюза была '#4FD1C5'


  return (
    <div>
      <HeaderMain />
      <PrivacyContainer />
      <Footer />
    </div>
  );
}